export const types = {
  CHANGE_ORGANIZATION_PROFILES_EDIT_MODE: 'CHANGE_ORGANIZATION_PROFILES_EDIT_MODE',
  SET_EDIT_FROM_ORGANIZATION_PROFILES: 'SET_EDIT_FROM_ORGANIZATION_PROFILES',
};
